export default __webpack_public_path__ + "static/media/imagen_becas-min.2b32ea6e.png";